import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import StatsSection from './components/StatsSection';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        email: siteInfo.email,
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '韩漫网 - 首页',
        description: siteInfo.description,
        url: siteInfo.url,
        isPartOf: {
          '@type': 'WebSite',
          name: siteInfo.name,
          url: siteInfo.url,
        },
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: 'https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20Korean%20manhwa%20style%20illustration%20of%20a%20magical%20library%20filled%20with%20floating%20books%20and%20comic%20pages&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="韩漫网_免费韩漫大全_好看的韩国漫画_无删减漫画下拉式在线观看"
        description={siteInfo.description}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotSection />
        <LatestSection />
        <StatsSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}